import { createContext } from "react";

const verificationContext = createContext();

export default verificationContext;
